exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-table--border[data-v-64e1aa4e],.el-table--group[data-v-64e1aa4e],.el-table td[data-v-64e1aa4e],.el-table th.is-leaf[data-v-64e1aa4e]{border-color:#000}.el-table--border[data-v-64e1aa4e]:after,.el-table--group[data-v-64e1aa4e]:after,.el-table[data-v-64e1aa4e]:before{background-color:#000}", ""]);

// exports
